import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { SavedOrder } from "./orderTypes";
import type { CreateOrUpdateOrderRequest } from "./ordersApi";
import { createOrder } from "./ordersApi";
import { logPurchase } from "../misc/firebase";

export const useCreateOrder = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const createOrderMutation = useMutation<SavedOrder, unknown, { order: CreateOrUpdateOrderRequest }>({
    mutationFn: ({ order }) => createOrder(order),
    onSuccess: (data) => {
      enqueueSnackbar(`Zamówienie ${data.name} zostało utworzone`, { variant: "success" });
      queryClient.setQueryData(["offers", data.id], data);
      logPurchase(
        data.id,
        data.products.map((p) => ({
          id: p.id,
          value: typeof p.price === "number" ? p.price : undefined,
          currency: p.currency,
        })),
      );
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się utworzyć zamówienia. Powód: ${(error as Error).message}`, {
        variant: "error",
      });
    },
  });

  return {
    onCreate: (order: CreateOrUpdateOrderRequest) => createOrderMutation.mutateAsync({ order }),
  };
};
